import { t, urlPrefix } from './i18n.js';

function displaySingleUserStats({ userName, userStats, thisEnsembleSlug }) {

    document.getElementById("multiple-users-stats").classList = "d-none";
    document.getElementById("single-user-stats").classList = "";
    
    const events = userStats.events;

    document.getElementById("single-stats-max-engagement").innerText = userStats.users_max_engagement;
    document.getElementById("single-stats-user-engagement").innerText = userStats.users_engagement;
    document.getElementById("single-stats-user-engagement-share").innerText = userStats.share_of_engagement + "%";

    document.getElementById("single-stats-user-checked-events").innerText = userStats.user_checked_events;
    document.getElementById("single-stats-user-presence").innerText = userStats.user_prsence;
    document.getElementById("single-stats-user-share-of-presence").innerText = userStats.share_of_presence + "%";

    document.getElementById("single-stats-user-not-checked-events").innerText = userStats.not_checked_events

    // and here we have to fil the table

    let tbody = document.getElementById("single-stats-events");
    tbody.innerHTML = "";

    let eventCount = 0;

    Object.entries(events).forEach(([key, eventData]) => {
        eventCount++;

        const row = document.createElement("tr");

        row.classList.add("single-stats-event-element");
        if (eventCount > 10) {
            row.classList.add("d-none");
        }

        row.innerHTML = `
            <td class="text-wrap">
                <span class="me-2"><a href="${urlPrefix()}/event/${thisEnsembleSlug}/${eventData[5]}">${eventData[0]}</a></span>
                ${eventData[4] ? `<div class="badge badge-info">${t('concert')}</div>` : ""}
            </td>
            <td class="text-wrap">${eventData[1]}</td>
            <td class="text-wrap">
                <span class="badge attendance-status-badge text-wrap ${eventData[3]}">${eventData[2]}</span>
            </td>
        `;

        tbody.appendChild(row);
    });

    if (eventCount > 10) {
        const moreRow = document.createElement("tr");
        moreRow.id = "show-more-events-stats-tr";
        moreRow.innerHTML = `
            <td colspan="3" class="text-center">
                <button id="show-more-events-stats-button" class="btn btn-primary mx-auto">${t('showMore')}</button>
            </td>
        `;
        tbody.appendChild(moreRow);


        // function to handle "show events" button
        document.getElementById("show-more-events-stats-button").addEventListener("click", function () {
            const hiddenElements = document.querySelectorAll('.single-stats-event-element.d-none');
            let count = 0;

            hiddenElements.forEach(function(element) {
                if (count < 10) {
                    element.classList.remove('d-none');
                    count++;
                }
            });

            if (document.querySelectorAll('.single-stats-event-element.d-none').length === 0) {
                document.getElementById('show-more-events-stats-tr').classList = "btn btn-primary mx-auto d-none";
            }
            
        });
    }
}


function displayTableStats(data, thisEnsembleSlug) {
    document.getElementById("single-user-stats").classList = "d-none";
    document.getElementById("multiple-users-stats").classList = "";

    const multipleStatsFullContainer = document.querySelector(".statistics-table-container");

    // here we remove all old stats
    multipleStatsFullContainer.querySelectorAll('.multiple-users-stats-row').forEach(el => el.remove());

    let membersCounter = 0;

    data.forEach(userStats => {
        membersCounter++;
        let userStatsRow = document.createElement("div");
        userStatsRow.classList = "statistics-table-row multiple-users-stats-row";

        userStatsRow.innerHTML = `
                <div class="statistics-table-cell text-wrap accordion" data-bs-toggle="collapse" data-bs-target="#details-${membersCounter}">
                    <button class="btn btn-link p-0 font-weight-bold wrapped-button-names">
                        <b>${userStats[0][0]} <span id="multiple-stats-last-name">${userStats[0][1]}</span></b>
                    </button>
                </div>
                <div class="statistics-table-cell"><b>${userStats[1].user_prsence}</b> (${userStats[1].user_checked_events})</div>
                <div class="statistics-table-cell"><b>${userStats[1].share_of_presence}%</b></div>
                <div class="statistics-table-cell"><b>${userStats[1].users_engagement}</b> (${userStats[1].users_max_engagement})</div>
                <div class="statistics-table-cell"><b>${userStats[1].share_of_engagement}%</b></div>
                <div class="statistics-table-cell"><b>${userStats[1].not_checked_events}</b></div>
        `
        
        let usersEventsDiv = document.createElement("div");
        usersEventsDiv.id = `details-${membersCounter}`;
        usersEventsDiv.classList = "statistics-user-events collapse"

        const usersEventsTable = document.createElement("table");
        usersEventsTable.classList = "w-100 table table-bordered multiple-stats-table";
        usersEventsTable.innerHTML = `
                <thead style="background-color: #6a8dec; color: white;">
                    <tr>
                        <th>${t('eventName')}</th>
                        <th>${t('eventDate')}</th>
                        <th>${t('attendanceStatus')}</th>
                    </tr>
                </thead>
                <tbody>
                </tbody>
        `
        
        const usersStatsTbody = usersEventsTable.querySelector("tbody");
        let usersEventsCounter = 0;

        userStats[1].events.forEach(eventStats => { 
            usersEventsCounter++;

            const row = document.createElement("tr");
            row.classList.add("multiple-stats-event-element");

            if (usersEventsCounter > 10) {
                row.classList.add("d-none");
            }
    
            row.innerHTML = `
                    <td>
                        <a href="${urlPrefix()}/event/${thisEnsembleSlug}/${eventStats[5]}">${eventStats[0]}</a>
                        ${eventStats[4] ? `<span class="me-2" style="margin-left: 15px;"><div class="badge badge-info">${t('concert')}</div></span>` : ""}
                    </td>
                    <td>${eventStats[1]}</td>
                    <td>
                        <span class="badge attendance-status-badge ${eventStats[3]}">${eventStats[2]}</span>
                    </td>
            `;

            usersStatsTbody.appendChild(row);

        });

        if (usersEventsCounter > 10) {
            const showMoreRow = document.createElement("tr");
            showMoreRow.id = "show-more-events-stats-tr";
            showMoreRow.innerHTML = `
                <td colspan="3" class="text-center">
                    <button id="multiple-show-more-events-stats-button" class="btn btn-primary mx-auto">${t('showMore')}</button>
                </td>
            `;

            usersStatsTbody.appendChild(showMoreRow);
    
            // function to handle "show events" button
            const buttonId = "multiple-show-more-events-stats-button-" + membersCounter;
            usersStatsTbody.querySelector(`#multiple-show-more-events-stats-button`).addEventListener("click", function () {
                const hiddenElements = usersEventsDiv.querySelectorAll(`.multiple-stats-event-element.d-none`);
                let count = 0;

                hiddenElements.forEach(function(element) {
                    if (count < 10) {
                        element.classList.remove('d-none');
                        count++;
                    }
                });

                if (usersEventsDiv.querySelectorAll(`.multiple-stats-event-element.d-none`).length === 0) {
                    usersEventsDiv.querySelector(`#multiple-show-more-events-stats-button`).classList.add("d-none");
                }
            
            });
                        
        }

        usersEventsDiv.appendChild(usersEventsTable);
        userStatsRow.appendChild(usersEventsDiv);
        multipleStatsFullContainer.appendChild(userStatsRow);

    });
}


function sendAjaxRequest(requestData, url, callback) {
    const xhr = new XMLHttpRequest();

    var csrftoken = $.cookie('csrftoken');

    xhr.open("POST", url, true);
    xhr.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
    xhr.setRequestHeader('X-CSRFToken', csrftoken);

    xhr.onreadystatechange = function () {
        if (xhr.readyState === 4) {
            if (xhr.status === 200) {
                callback(JSON.parse(xhr.responseText));
            } else {
                console.error("AJAX response error:");
            }
        }
    };

    xhr.send(JSON.stringify(requestData));
}

// Button to load stats on given dates/members/type
$(document).ready(function () {
    $('.search-stats-btn').on('click', function () {
        const fromDateStr = $('.stats-from-date').val();
        const toDateStr = $('.stats-to-date').val();

        // The datepicker parses its own value, whatever the date format of the active language
        const fromDate = $('.stats-from-date').datepicker('getDate');
        const toDate = $('.stats-to-date').datepicker('getDate');

        if (!fromDate || !toDate) {
            return;
        }

        if (fromDate > toDate){
            alert(t('dateRangeInvalid'));
            return;
        } else {
            
            const button = $(this);

            // here we get list of users we want to check
            const selectedValues = $('.stats-members option:selected').map(function() {
                return $(this).val();
            }).get(); // return as table


            const ensembleSlug = button.data("ensemble")
            const eventsType = document.querySelector('input[name="event-type"]:checked');
            const checkboxAllMembers = document.getElementById("see-all-members-checkbox");
            let showAllMembers = false
            if (checkboxAllMembers.checked) {
                showAllMembers = true
            };

            const requestData = {
                ensemble: ensembleSlug,
                member_id: button.data("member_id"),
                from_date: fromDateStr,
                to_date: toDateStr,
                ensemble_members: selectedValues,
                events_type: eventsType.value,
                show_all_members: showAllMembers,
            };

            const url = `${urlPrefix()}/api/${ensembleSlug}/attendance-statistics`;

            sendAjaxRequest(requestData, url, function(responseData) {
                
                if (responseData.length === 1) {
                    displaySingleUserStats({ userName: responseData[0][0], userStats: responseData[0][1], thisEnsembleSlug: ensembleSlug});
                } else {
                    displayTableStats(responseData, ensembleSlug);
                }
            });                
        }
    });
});


// function to show/hide list of members to show stats
document.addEventListener("DOMContentLoaded", function () {
    const checkboxShowAllMembers = document.getElementById("see-all-members-checkbox");
    const membersSection = document.getElementById("chose-members-to-show-stats");

    if (checkboxShowAllMembers) {
        // checking checkbox on page start
        if (checkboxShowAllMembers.checked) {
            membersSection.classList.add("d-none");
        } else {
            membersSection.classList.remove("d-none");
        }

        // showing/hiding members select
        checkboxShowAllMembers.addEventListener("change", function () {
            if (this.checked) {
                membersSection.classList.add("d-none");
            } else {
                membersSection.classList.remove("d-none");
            }
        });
    }

    // Add event listener for "show more" button that exists on initial page load
    const showMoreButton = document.getElementById("show-more-events-stats-button");
    if (showMoreButton) {
        showMoreButton.addEventListener("click", function () {
            const hiddenElements = document.querySelectorAll('.single-stats-event-element.d-none');
            let count = 0;

            hiddenElements.forEach(function(element) {
                if (count < 10) {
                    element.classList.remove('d-none');
                    count++;
                }
            });

            if (document.querySelectorAll('.single-stats-event-element.d-none').length === 0) {
                document.getElementById('show-more-events-stats-tr').classList.add("d-none");
            }
        });
    }
});


document.addEventListener("DOMContentLoaded", function () {
    // we get all sorting buttons
    document.querySelectorAll(".sort-btn").forEach(btn => {
        btn.addEventListener("click", function (event) {
            event.preventDefault();

            const header = this.closest(".statistics-table-header");
            const column = header.dataset.sort; // info of the column to sort by
            const order = this.dataset.order; // "asc" or "desc"

            const rows = Array.from(document.querySelectorAll(".multiple-users-stats-row"));

            rows.sort((a, b) => {
                let aValue = getValue(a, column);
                let bValue = getValue(b, column);

                if (typeof aValue === "number" && typeof bValue === "number") {
                    return order === "asc" ? aValue - bValue : bValue - aValue;
                } else {
                    return order === "asc" ? aValue.localeCompare(bValue) : bValue.localeCompare(aValue);
                }
            });

            // and we have to set the right sequence in DOM
            const container = document.querySelector("#multiple-users-stats .statistics-table-container");
            rows.forEach(row => container.appendChild(row));
        });
    });

    // function to get value to sort
    function getValue(row, column) {
        switch (column) {
            case "name":
                return row.querySelector("#multiple-stats-last-name").textContent.trim();
            case "presence":
                return parseInt(row.children[1].querySelector("b").textContent.trim()) || 0;
            case "presence-percent":
                return parseFloat(row.children[2].textContent.match(/\d+\.\d+/)) || 0;
            case "engagement":
                return parseFloat(row.children[3].querySelector("b").textContent.match(/-?\d+\.\d+/)) || 0;
            case "engagement-percent":
                return parseFloat(row.children[4].textContent.match(/-?\d+\.\d+/)) || 0;
            case "unchecked-events":
                return parseInt(row.children[5].textContent.trim()) || 0;
            default:
                return row.textContent.trim();
        }
    }
});
